import React from 'react';
import Parser from 'html-react-parser';
import './Details.css';

class Details extends React.Component {
  render() {
    const getEvent = this.props.hideDetails
    const details = this.props.data

    return (
      <div className="details-wrapper">
        <div className="details">
          <a onClick={getEvent} className="close">&nbsp;</a>
          <h1 className="details-heading">{details.title}</h1>
          <h4 className="details-subheading">{details.type}</h4>
          
          <div className="details-row">
            <div className="details-col details-col--right">
              <h6 className="details-label">Project Info:</h6>
              <p className="details-description">{Parser(details.summary)}</p>
              <a className="details-heading-link" href={details.url} target="_blank">Visit Website</a>
            </div>
            
            <div className="details-col">
              <h5 className="details-label">Roles:</h5>
              <div className="details-description">{Parser(details.description)}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Details



// WEBPACK FOOTER //
// ./src/Shared/Details.js